function initMobileFilters( form ) {
    var count = 0;

    var filtersToIgnore = [
        'order',
        'author',
        'locationFreeText',
        'categoryFreeText',
    ];

    var filters = form.querySelectorAll( 'input,select' );

    filters.forEach( function( el ) {
        if ( filtersToIgnore.includes( el.name ) ) {
            return;
        }

        if ( el.type === 'checkbox' && el.checked ) {
            count++;
            return;
        }

        if ( el.value && el.value.length > 0 ) {
            count++;
        }
    } );

    var counterElements = document.querySelectorAll( 'button[data-action="open-search-filters"] .counter' );

    if ( count === 0 ) {
        counterElements.forEach( function( counterElement ) {
            counterElement.classList.add( 'd-none' );
        } );
    } else {
        counterElements.forEach( function( counterElement ) {
            counterElement.innerHTML = count;
        } );
    }
}

export default initMobileFilters;
